import { render } from "./IndexAffectation.vue?vue&type=template&id=5aa08050"
import script from "./IndexAffectation.vue?vue&type=script&lang=js"
export * from "./IndexAffectation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__